module.exports = __webpack_public_path__ + "static/310project-899c15dc6c1607aa09d5a76eeffedf6b.gif";